import { Tag, TagType } from 'lib/types/tags';
import { TagValueForm } from 'components/TagValueForm/TagValueForm';
import { TagChip } from 'components/TagChip';
import { TAG_TYPE_IDS } from 'lib/constants';
import { AddTagButton } from './AddTagButton';

interface Props {
  tags: Tag[];
  tagType: TagType;
  editMode: boolean;
  onSelect: (tag: Tag) => void;
  onRemove: (tag: Tag) => void;
  onAdd: (tagTypeId: number | null) => void;
  postId?: number;
}

export const TagRow = ({
  tags, tagType, editMode, onSelect, onRemove, onAdd, postId,
}: Props) => {
  const onSelectTag = async (selectedTagValue: any) => {
    await onSelect(selectedTagValue);
    onAdd(null);
  };

  const onCancel = () => {
    onAdd(null);
  };

  const getAddTagLabel = (type: TagType) => {
    if (type.id === TAG_TYPE_IDS.event) {
      return 'Add event / campaign';
    }
    return 'Add tag';
  };

  return (
    <div className="flex flex-wrap md:flex-nowrap items-center">
      <div className="w-full md:w-4/5 py-2">
        <ul className="flex flex-wrap gap-2 list-none">
          {tags?.map((tag) => (
            <TagChip tag={tag} tagType={tagType} onRemove={onRemove} key={tag.id} />
          ))}
          {editMode ? (
            <TagValueForm
              tagType={tagType}
              onSelectTag={onSelectTag}
              onCancelAddTag={onCancel}
              postId={postId}
            />
          )
            : (
              <AddTagButton
                onClickAddTag={() => onAdd(tagType.id)}
                label={getAddTagLabel(tagType)}
              />
            )}
        </ul>
      </div>
    </div>
  );
};
